import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';

import {AppRoutingModule} from '@/app-routing.module';
import {AppComponent} from './app.component';
import {MainComponent} from '@modules/main/main.component';
import {LoginComponent} from '@modules/login/login.component';
import {HeaderComponent} from '@modules/main/header/header.component';
import {FooterComponent} from '@modules/main/footer/footer.component';
import {MenuSidebarComponent} from '@modules/main/menu-sidebar/menu-sidebar.component';
import {BlankComponent} from '@pages/blank/blank.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ProfileComponent} from '@pages/profile/profile.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RegisterComponent} from '@modules/register/register.component';
import {DashboardComponent} from '@pages/dashboard/dashboard.component';
import {ToastrModule} from 'ngx-toastr';
import {MessagesComponent} from '@modules/main/header/messages/messages.component';
import {NotificationsComponent} from '@modules/main/header/notifications/notifications.component';

import {DatePipe, registerLocaleData} from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeEsCL from '@angular/common/locales/es-CL';
import {UserComponent} from '@modules/main/header/user/user.component';
import {ForgotPasswordComponent} from '@modules/forgot-password/forgot-password.component';
import {RecoverPasswordComponent} from '@modules/recover-password/recover-password.component';
import {LanguageComponent} from '@modules/main/header/language/language.component';
import {MainMenuComponent} from './pages/main-menu/main-menu.component';
import {SubMenuComponent} from './pages/main-menu/sub-menu/sub-menu.component';
import {MenuItemComponent} from './components/menu-item/menu-item.component';
import {ControlSidebarComponent} from './modules/main/control-sidebar/control-sidebar.component';
import {StoreModule} from '@ngrx/store';
import {authReducer} from './store/auth/reducer';
import {uiReducer} from './store/ui/reducer';
import {ProfabricComponentsModule} from '@profabric/angular-components';
import {defineCustomElements} from '@profabric/web-components/loader';
import {SidebarSearchComponent} from './components/sidebar-search/sidebar-search.component';
import { AuthInterceptorService } from '@services/auth-interceptor.service';
import { PedidosTodosComponent } from './pages/pedidos/pedidos-todos/pedidos-todos.component';
import { PedidosHoyComponent } from './pages/pedidos/pedidos-hoy/pedidos-hoy.component';
import { PedidosEnProcesoComponent } from './pages/pedidos/pedidos-en-proceso/pedidos-en-proceso.component';
import { PedidosDeliveryComponent } from './pages/pedidos/pedidos-delivery/pedidos-delivery.component';
import { ClienteComponent } from './pages/clientes/cliente/cliente.component';
import { ClientesDeudoresComponent } from './pages/clientes/clientes-deudores/clientes-deudores.component';
import { ClientesTodosComponent } from './pages/clientes/clientes-todos/clientes-todos.component';
import { ProductosComponent } from './pages/productos/productos.component';
import { InformesComponent } from './pages/informes/informes.component';
import { ListaClientesComponent } from './components/clientes/lista-clientes/lista-clientes.component';
import { NewClienteComponent } from './components/clientes/new-cliente/new-cliente.component';
import { EditClienteComponent } from './components/clientes/edit-cliente/edit-cliente.component';
import { SearchListaClientePipe } from '@components/clientes/lista-clientes/search-lista-cliente.pipe';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NewProductoComponent } from './components/productos/new-producto/new-producto.component';
import { ListaProductosComponent } from './components/productos/lista-productos/lista-productos.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ListaPedidosComponent } from './components/pedidos/lista-pedidos/lista-pedidos.component';
import { FormsToolsModule } from '@components/forms-tools/forms-tools.module';
import { ModalCambiaEstadoComponent } from './components/pedidos/modal-cambia-estado/modal-cambia-estado.component';
import { TicketComponent } from './components/ticket/ticket.component';
import { PedidoComponent } from './pages/pedidos/pedido/pedido.component';
import { ModalMetodoPagoComponent } from './components/pedidos/modal-metodo-pago/modal-metodo-pago.component';
import { LoadingComponent } from './components/loading/loading.component';
import { SearchClienteDeudoresPipe } from '@pages/clientes/clientes-deudores/search-clientes-deudores.pipe';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { PaginationPipe } from './utils/pagination.pipe';
import { FooterPaginationComponent } from './components/footer-pagination/footer-pagination.component';
import { ProductosDeliveryComponent } from './pages/productos-delivery/productos-delivery.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AddDireccionComponent } from './components/clientes/add-direccion/add-direccion.component';
import { UpdDireccionComponent } from './components/clientes/upd-direccion/upd-direccion.component';
import { SortPipe } from './utils/sort.pipe';
import { DetalleComponent } from './modules/detalle/detalle.component';
import { TagInputModule } from 'ngx-chips';
import { ArqueoComponent } from './pages/arqueo/arqueo.component';
import { ListaArqueoComponent } from './components/arqueo/lista-arqueo/lista-arqueo.component';
import { DetalleArqueoComponent } from './components/arqueo/detalle-arqueo/detalle-arqueo.component';
import { ModalMovimientoComponent } from './components/arqueo/modal-movimiento/modal-movimiento.component';
import { TicketGlobalComponent } from './components/ticket-global/ticket-global.component';

defineCustomElements();
registerLocaleData(localeEn, 'en-EN');
registerLocaleData(localeEsCL, 'es-CL');

@NgModule({
    declarations: [
        AppComponent,
        MainComponent,
        LoginComponent,
        HeaderComponent,
        FooterComponent,
        MenuSidebarComponent,
        BlankComponent,
        ProfileComponent,
        RegisterComponent,
        DashboardComponent,
        MessagesComponent,
        NotificationsComponent,
        UserComponent,
        ForgotPasswordComponent,
        RecoverPasswordComponent,
        LanguageComponent,
        MainMenuComponent,
        SubMenuComponent,
        MenuItemComponent,
        ControlSidebarComponent,
        SidebarSearchComponent,
        PedidosTodosComponent,
        PedidosHoyComponent,
        PedidosEnProcesoComponent,
        PedidosDeliveryComponent,
        ClienteComponent,
        ClientesDeudoresComponent,
        ClientesTodosComponent,
        ProductosComponent,
        InformesComponent,
        ListaClientesComponent,
        SearchListaClientePipe,
        SearchClienteDeudoresPipe,
        NewClienteComponent,
        EditClienteComponent,
        NewProductoComponent,
        ListaProductosComponent,
        ListaPedidosComponent,
        ModalCambiaEstadoComponent,
        TicketComponent,
        PedidoComponent,
        ModalMetodoPagoComponent,
        LoadingComponent,
        PaginationPipe,
        SortPipe,
        FooterPaginationComponent,
        ProductosDeliveryComponent,
        AddDireccionComponent,
        UpdDireccionComponent,
        DetalleComponent,
        ArqueoComponent,
        ListaArqueoComponent,
        DetalleArqueoComponent,
        ModalMovimientoComponent,
        TicketGlobalComponent
    ],
    imports: [
        BrowserModule,
        StoreModule.forRoot({auth: authReducer, ui: uiReducer}),
        HttpClientModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true
        }),
        ProfabricComponentsModule,
        NgbModule,
        NgxDatatableModule,
        FormsToolsModule,
        PaginationModule.forRoot(),
        TabsModule.forRoot(),
        NgxChartsModule,
        TagInputModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true,
        },
        DatePipe,
        NgbActiveModal,
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
